import React from "react";
import { Logo_2 } from "../Assets";

const Footer = () => {
  return (
    <footer class="bg-white rounded-lg shadow dark:bg-gray-900 m-4">
      <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
        <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">
          © 2024 All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
